import React from 'react';
import { Formik, Form } from 'formik'
import { Button, Typography } from '@material-ui/core'
import CustomTextField from '../forgot-password/CustomTextField'
import CustomButton from '../forgot-password/CustomButton'
import { isEmailExistRequest } from '../../services/api.service';

export default function LoginForm({ email, onSubmit, onSuccess, onFailure, onChangePassword }) {

  return <div>
    <Typography variant="h5" align="center" style={{ textAlign: 'center', margin: '24px 0 32px 0'}}>
      Connexion
    </Typography>
    <Formik
      initialValues={{
        email,
        password: '',
      }}
      validate={(values) => {
        const errors = {}

        if (!values.email) {
          errors.email = 'Votre email est nécessaire'
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
          errors.email = 'Email Incorrect'
        }

        if (!values.password) {
          errors.password = 'Votre mot de passe est nécessaire'
        }

        return errors
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true)
        onSubmit(values)
          .then((data) => {
            setSubmitting(false);
            onSuccess(values);
          })
          .catch((error) => {
            setSubmitting(false);
            onFailure(error);
          });
      }}
    >
      {({ submitForm, isSubmitting }) => (
        <Form>
          <CustomTextField
            name="email"
            placeholder="Adresse e-mail"
            type="email"
            required
          />
          <CustomTextField
            name="password"
            placeholder="Mot de passe"
            type="password"
            required
            style={{ marginBottom: 16 }}
          />
          <Button link onClick={onChangePassword} style={{ 
            marginLeft: 'auto',
            display: 'block',
            marginBottom: 16,
          }}>
            Mot de passe oublié ?
          </Button>
          <CustomButton
            color="secondary"
            onClick={submitForm}
            disabled={isSubmitting}
          >
            CONTINUER
          </CustomButton>
          <a href="/conditions-generales">
            <Typography style={{ textAlign: 'center', color: '#4c5052', marginTop: 20 }}>
              Conditions d'utilisation
            </Typography>
          </a>
        </Form>
      )}
    </Formik>
  </div>;
}
